import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-fb9774dc"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "top"
};
const _hoisted_2 = {
  class: "flex flex-center m-b"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "m-r-10 white-nowrap"
}, "所在省市", -1));
const _hoisted_4 = {
  class: "flex flex-center m-b"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "m-r-10 white-nowrap"
}, "街道小区", -1));
const _hoisted_6 = {
  class: "down flex flex-between flex-center"
};
const _hoisted_7 = ["placeholder", "disabled"];
const _hoisted_8 = {
  class: "door"
};
const _hoisted_9 = {
  class: "flex flex-center"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "m-r-10 white-nowrap"
}, "门牌号码", -1));
const _hoisted_11 = {
  class: "down flex flex-between flex-center"
};
const _hoisted_12 = ["placeholder", "disabled"];
const _hoisted_13 = {
  key: 0,
  class: "suggestion"
};
const _hoisted_14 = {
  id: "suggestionList"
};
const _hoisted_15 = ["onClick"];
const _hoisted_16 = {
  class: "item_info"
};
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "backmap"
}, null, -1));
const _hoisted_18 = {
  class: "btn flex align-center flex-between"
};
import { ref, reactive, onMounted, watch, nextTick, getCurrentInstance } from "vue";
import commonMethod from "../common/common.ts";
import _ from 'lodash';
export default /*#__PURE__*/_defineComponent({
  __name: 'map',
  props: {
    // 省市区
    area: {
      default: '',
      type: String
    },
    // 详细地址
    adr: {
      default: '',
      type: String
    },
    // 门牌号
    door: {
      default: '',
      type: String
    },
    // 产品类型id
    stId: {
      default: 1,
      type: [String, Number]
    },
    // 地区id
    saId: {
      default: 1,
      type: [String, Number]
    },
    // 地区列表
    list: {
      default: [],
      type: Array
    },
    // 订单编号
    orderId: {
      default: '',
      type: String
    },
    // 市级区域码
    cityCode: {
      default: '',
      type: String
    },
    // 区级区域码
    districtCode: {
      default: '',
      type: String
    }
  },
  emits: ['cancel', 'submit'],
  setup(__props, {
    emit: __emit
  }) {
    const {
      proxy
    } = getCurrentInstance();
    const props = __props;
    const cityValue = ref(''); // 省市区
    const address = ref(''); // 详细地址
    const doorplate = ref(''); // 门牌号
    const areaLists = ref([]); // 省市区列表
    const sa_id = ref(0); // 地区id
    const city_code = ref(0); // 市级区域码
    const district_code = ref(0); // 区级区域码
    watch(props, () => {
      cityValue.value = props.area;
      address.value = props.adr;
      doorplate.value = props.door;
      areaLists.value = props.list;
      city_code.value = props.cityCode;
      district_code.value = props.districtCode;
      nextTick(() => {
        if (sa_id.value !== props.saId) {
          if (city_code.value > 0 && district_code.value > 0) {
            mapData.district.getChildren({
              id: city_code.value
            }).then(res => {
              let data = res.result[0].filter(item => item.id == district_code.value);
              if (data.length > 0) {
                drawPolygon(data[0].id, data[0].polygon);
                getNoServe(1);
                // 获取小区列表
                getCommunity();
              } else {
                findBorder();
              }
            });
          } else {
            findBorder();
          }
        }
        sa_id.value = props.saId;
      });
    }, {
      immediate: true
    });
    // 地图数据
    const mapData = {
      map: '',
      polygons: null,
      marker: null,
      geocoder: new TMap.service.Geocoder(),
      district: new TMap.service.District({
        polygon: 2
      }),
      suggest: new TMap.service.Suggestion({
        pageSize: 10,
        regionFix: true // 搜索无结果时是否固定在当前城市
      })
    };
    const showSugg = ref(false); // 显示搜索列表
    const suggestionList = ref([]); // 用来存放搜索框返回的数据
    onMounted(() => {
      mapData.map = new TMap.Map(document.getElementById('backmap'), {
        center: new TMap.LatLng(39.908, 116.398),
        zoom: 14,
        pitch: 0,
        rotation: 0 //设置地图旋转角度
      });
      // 移除罗盘控件
      mapData.map.removeControl(TMap.constants.DEFAULT_CONTROL_ID.ROTATION);
      mapData.map.removeControl(TMap.constants.DEFAULT_CONTROL_ID.SCALE);
      mapData.map.on('click', evt => {
        // 如果没有选择地区就return
        if (!cityValue.value) return;
        addMark(evt.latLng); //添加标记点
        // 如果搜索框有内容就清空
        showSugg.value = false;
        // 如果地图上有覆盖物，再去找是否点击在区域内
        if (mapData.polygons.geometries.length > 0) {
          isAdminArea(mapData.polygons.geometries, evt.latLng.lat, evt.latLng.lng, 1);
        } else {
          // 没有覆盖物就直接赋值
          if (evt.poi) {
            address.value = evt.poi.name;
          }
        }
      });
      mapData.polygons = new TMap.MultiPolygon({
        map: mapData.map,
        geometries: []
      });
    });
    const picker = ref(null);
    // 地址选择联动时触发
    const areaChange = (value, index) => {
      if (index == 0) {
        picker.value.setColumnValues(1, value[index].children);
        picker.value.setColumnValues(2, value[index].children[0].children);
        // 选择第一列时，如果第二列和第三列没有选择第一个，就更改选中
        if (areaLists.value[1].defaultIndex > 0 || areaLists.value[2].defaultIndex > 0) {
          areaLists.value[1].defaultIndex = 0;
          areaLists.value[2].defaultIndex = 0;
        }
      } else if (index == 1) {
        picker.value.setColumnValues(2, value[index].children);
        areaLists.value[2].defaultIndex = 0;
      }
    };
    const drawpoly = ref([]); // 不可服务列表
    const adrShow = ref(false);
    const suAddress = ref(''); //暂存点击列表的地址
    // 省市区选择完成
    const onFinish = value => {
      cityValue.value = value[0].text + '/' + value[1].text + '/' + value[2].text;
      city_code.value = value[2].city_code;
      district_code.value = value[2].area_code;
      for (let s of drawpoly.value) {
        s.setMap(null);
      }
      if (city_code.value > 0 && district_code.value > 0) {
        mapData.district.getChildren({
          id: city_code.value
        }).then(res => {
          let data = res.result[0].filter(item => item.id == district_code.value);
          // 如果有区域码就直接绘图，没有再逐个找
          if (data.length > 0) {
            drawPolygon(data[0].id, data[0].polygon);
            getNoServe(1);
            getCommunity();
          } else {
            findBorder();
          }
        });
      } else {
        findBorder();
      }
      let label = picker.value.getValues();
      sa_id.value = label[2].sa_id;
      adrShow.value = false;
      if (cityValue.value == props.area) {
        address.value = props.adr;
        doorplate.value = props.door;
      } else {
        address.value = suAddress.value = doorplate.value = '';
      }
    };
    // 获取小区名字
    const communityList = ref([]); // 小区列表
    const getCommunity = () => {
      proxy.$api.post(`${proxy.$url}Map/getInfoFromAdcode`, {
        adcode: district_code.value
      }).then(res => {
        if (res.status == 1) {
          communityList.value = suggestionList.value = res.data;
        }
      });
    };
    // 详细地址输入框  加入节流函数，降低触发频率
    const cityValueFull = ref('');
    const getSuggestions = _.throttle(() => {
      let keyword = '';
      if (cityValueFull.value) {
        keyword = cityValueFull.value + address.value;
      } else {
        keyword = cityValue.value + address.value;
      }
      if (address.value) {
        suggestionList.value = communityList.value.filter(item => item.title.indexOf(address.value) != -1);
        if (suggestionList.value.length < 1) {
          mapData.suggest.getSuggestions({
            keyword: keyword,
            location: mapData.map.getCenter()
          }).then(result => {
            suggestionList.value = result.data;
            showSugg.value = true;
          });
        } else {
          showSugg.value = true;
        }
      } else {
        suggestionList.value = [];
        showSugg.value = false;
        doorplate.value = '';
      }
    }, 1000);
    // 详细地址输入框失去焦点
    const inputBlur = () => {
      setTimeout(() => {
        showSugg.value = false;
      }, 300);
    };
    // 点击搜索出来的地址
    const infoWindowList = Array(10);
    const setSuggestion = item => {
      // 输入框赋值
      address.value = suAddress.value = item.title;
      checkArea(item.title);
      // 点击输入提示后，于地图中用点标记绘制该地点，并显示信息窗体，包含其名称、地址等信息
      infoWindowList.forEach(infoWindow => {
        infoWindow.close();
      });
      infoWindowList.length = 0;
    };
    // 校验地址
    const districtCoor = reactive({
      lat: '',
      lng: ''
    });
    const isSubmit = ref(false);
    const noDistrict = ref(false); //是否有行政区域
    const checkArea = address => {
      if (noDistrict.value) {
        return;
      }
      return new Promise((resolve, reject) => {
        if (cityValueFull.value) {
          address = cityValueFull.value + address;
        } else {
          address = cityValue.value + address;
        }
        mapData.geocoder.getLocation({
          address
        }).then(result => {
          showSugg.value = false;
          let loc = result.result.location;
          if (districtCoor.lat && districtCoor.lat === loc.lat && districtCoor.lng == loc.lng) {
            isSubmit.value = false;
            commonMethod.toast('', '未在此区域内找到所填写的详细地址，建议您在地图上选点操作', 3000);
            if (mapData.marker) {
              mapData.marker.setMap(null);
              mapData.marker = null;
            }
            resolve();
          } else {
            if (mapData.polygons.geometries.length > 0) {
              isAdminArea(mapData.polygons.geometries, loc.lat, loc.lng, 2);
            } else {
              isSubmit.value = true;
            }
            addMark(loc);
            resolve();
          }
        }).catch(() => {
          isSubmit.value = true;
          resolve();
        });
      });
    };
    // 判断点是否在所选的行政区域内
    const noServeArea = ref([]); // 不可服务区域列表
    const isAdminArea = (value, lat, lng, type) => {
      // 没有行政区域
      if (noDistrict.value) {
        return;
      }
      // 如果不在区域内，输入框赋值为空
      if (!checkPolygon(value, lat, lng)) {
        address.value = suAddress.value = doorplate.value = '';
        commonMethod.toast('', '不在所选服务区域内');
      } else {
        // 如果有不可服务区域就继续校验
        if (noServeArea.value.length > 0) {
          isArea(lat, lng, type);
        } else {
          isSubmit.value = true;
          // 如果是地图点击再赋值，手输的不变详细地址
          if (type == 1) {
            let location = new TMap.LatLng(lat, lng);
            // 将给定的坐标位置转换为地址
            mapData.geocoder.getAddress({
              location: location
            }).then(({
              result
            }) => {
              address.value = result.address_reference.town.title + result.address_reference.landmark_l2.title;
              doorplate.value = '';
            });
          }
        }
      }
    };
    // 判断点是否在所选的行政区域内
    const checkPolygon = (value, lat, lng) => {
      let arr = [];
      let position = new TMap.LatLng(lat, lng);
      for (let item of value) {
        let getLabelText = pos => {
          return TMap.geometry.isPointInPolygon(pos, item.paths) ? "" : "不在";
        };
        if (getLabelText(position)) {
          arr.push(false);
        } else {
          arr.push(true);
        }
      }
      // 只要有一个是true，说明就在行政区域内
      return arr.some(item => item == true);
    };
    // 判断点是否在不可服务区域内
    const isArea = (lat, lng, type) => {
      let arr = [];
      noServeArea.value.map(item => {
        let position = new TMap.LatLng(lat, lng);
        let getLabelText = pos => {
          return TMap.geometry.isPointInPolygon(pos, item) ? "无法服务" : "";
        };
        if (getLabelText(position)) {
          arr.push(false);
        } else {
          arr.push(true);
        }
      });
      // 都等于true说明可以服务
      if (arr.every(item => item == true)) {
        isSubmit.value = true;
        if (type == 1) {
          let location = new TMap.LatLng(lat, lng);
          // 将给定的坐标位置转换为地址
          mapData.geocoder.getAddress({
            location: location
          }).then(({
            result
          }) => {
            address.value = result.address_reference.town.title + result.address_reference.landmark_l2.title;
          });
        }
      } else {
        address.value = suAddress.value = doorplate.value = '';
        commonMethod.toast('', "此地址无法服务");
      }
    };
    // 查询不可服务的地区
    const getNoServe = type => {
      let value = {};
      if (type == 1) {
        value = {
          sa_id: sa_id.value,
          map_type: 2
        };
      } else {
        value = {
          st_id: stId.value,
          city: cityValue.value.split("/")[1],
          map_type: 2
        };
      }
      proxy.$api.post(`${proxy.$url}Map/unserviceableArea`, value).then(res => {
        noServeArea.value = [];
        if (res.data && res.data.length > 0) {
          let list = res.data;
          let newList = null;
          // 循环数组看看看有几处不可服务区域
          for (let value of list) {
            // 把里面的每天数据改成腾讯地图的格式
            newList = value.map(it => {
              return new TMap.LatLng(it[1], it[0]);
            });
            noServeArea.value.push(newList);
          }
          nextTick(() => {
            drawMap();
          });
        }
      });
    };
    // 绘制不可服务行政区域
    const drawMap = () => {
      drawpoly.value = [];
      noServeArea.value.map((item, index) => {
        drawpoly.value.push(new TMap.MultiPolygon({
          id: 'polygon-layer' + index,
          map: mapData.map,
          // 设置绘制区域颜色
          styles: {
            polygon: new TMap.PolygonStyle({
              color: 'rgba(255,0,0,.3)',
              borderColor: '#f00'
            })
          },
          geometries: [{
            id: 'polygon',
            paths: item,
            styleId: 'polygon'
          }]
        }));
      });
    };
    // 绘制行政区域
    const provinceFull = ref(''); // 省级全称
    const cityFull = ref(''); // 市级全称
    const districtFull = ref(''); // 区级全程
    const findBorder = () => {
      // 把最后一级的地址截掉一位，防止最后一位有的是区，有的是县
      let city = cityValue.value;
      if (city != '河南/安阳/安阳县') {
        city = cityValue.value.substring(0, cityValue.value.length - 1);
      }
      let cityList = [],
        arr = city.split("/");
      provinceFull.value = cityFull.value = districtFull.value = '';
      // 1. 获取省级
      mapData.district.getChildren().then(result => {
        // 2. 拿选择的地址去省级查找
        let data = result.result[0].filter(item => item.name.indexOf(arr[0]) != -1 || arr[0].indexOf(item.name) != -1);
        provinceFull.value = data[0].fullname;
        // 3.找到所属省的id，再查找市级
        mapData.district.getChildren({
          id: data[0].id
        }).then(res => {
          cityList = res.result[0];
          if (city == '河北/保定/安新' || city == '河北/保定/雄' || city == '河北/保定/容城') {
            let xiongan = cityList.filter(item => item.fullname == '雄安新区');
            drawPolygon(xiongan[0].id, xiongan[0].polygon);
            getNoServe(1);
            return;
          }
          // 判断cityList是否是最后一级，比如北京、上海...
          // 4. 这里直辖市直接返回最后一级
          let data1 = cityList.filter(item => item.fullname.indexOf(arr[2]) != -1 || arr[2].indexOf(item.fullname) != -1);
          if (data1.length > 0) {
            // 5.如果是最后一级就直接绘图
            drawPolygon(data1[0].id, data1[0].polygon);
            getNoServe(1);
            // 直接给最后一层赋值
            cityFull.value = data[0].fullname;
            districtFull.value = data1[0].fullname;
          } else {
            // 6. 不是直辖市的拿选择的地址去市级查找
            let data2 = cityList.filter(item => item.name.indexOf(arr[1]) != -1 || arr[1].indexOf(item.name) != -1);
            cityFull.value = data2[0].fullname;
            // 7. 找出来市级的id
            mapData.district.getChildren({
              id: data2[0].id
            }).then(value => {
              let noList = []; // 用于存放找不到的数据，有几种特殊情况的区也是找不到，例如高新、经济开发、经开
              for (let item of value.result[0]) {
                // 8. 如果含有polygon说明下面还有级别
                if (item.polygon) {
                  if (item.fullname.indexOf(arr[2]) != -1 || arr[2].indexOf(item.fullname) != -1) {
                    noList.push(true);
                    districtFull.value = item.fullname;
                    drawPolygon(item.id, item.polygon);
                    getNoServe(1);
                  } else {
                    noList.push(false);
                  }
                } else {
                  // 9. 没有的话就去划市级地图（东莞）
                  let arr2 = cityList.filter(it => it.fullname == item.fullname);
                  drawPolygon(arr2[0].id, arr2[0].polygon);
                  getNoServe(2);
                  districtFull.value = arr[2];
                }
              }
              // 如果在国家级行政区里面没找到这个选择的这个区，就以市级去划区域
              if (!noList.some(item => item == true)) {
                drawPolygon(data2[0].id, data2[0].polygon);
                getNoServe(2);
              }
            }).catch(() => {
              noDistrict.value = true;
            });
          }
        }).catch(() => {
          noDistrict.value = true;
        });
      }).catch(() => {
        noDistrict.value = true;
      });
    };
    // 绘制区域
    const drawPolygon = (placeId, polygonArray) => {
      // 如果没有行政区域
      if (polygonArray.length <= 0) {
        noDistrict.value = true;
        return;
      } else {
        noDistrict.value = false;
      }
      // 根据多边形顶点坐标数组绘制多边形
      mapData.polygons.remove(mapData.polygons.getGeometries().map(item => item.id));
      let bounds = [];
      let newGeometries = polygonArray.map((polygon, index) => {
        bounds.push(fitBounds(polygon));
        return {
          id: `${placeId}_${index}`,
          paths: polygon
        };
      });
      bounds = bounds.reduce((a, b) => {
        return fitBounds([a.getNorthEast(), a.getSouthWest(), b.getNorthEast(), b.getSouthWest()]);
      });
      mapData.polygons.updateGeometries(newGeometries);
      mapData.map.fitBounds(bounds);
      nextTick(() => {
        if (provinceFull.value && cityFull.value && districtFull.value) {
          cityValueFull.value = provinceFull.value + cityFull.value + districtFull.value;
        } else {
          cityValueFull.value = cityValue.value;
        }
        getProvinceCenter();
      });
    };
    // 由多边形顶点坐标数组计算能完整呈现该多边形的最小矩形范围
    const fitBounds = latLngList => {
      if (latLngList.length === 0) {
        return null;
      }
      let boundsN = latLngList[0].getLat();
      let boundsS = boundsN;
      let boundsW = latLngList[0].getLng();
      let boundsE = boundsW;
      latLngList.forEach(point => {
        point.getLat() > boundsN && (boundsN = point.getLat());
        point.getLat() < boundsS && (boundsS = point.getLat());
        point.getLng() > boundsE && (boundsE = point.getLng());
        point.getLng() < boundsW && (boundsW = point.getLng());
      });
      return new TMap.LatLngBounds(new TMap.LatLng(boundsS, boundsW), new TMap.LatLng(boundsN, boundsE));
    };
    // 获取这个省的经纬度
    const getProvinceCenter = () => {
      mapData.geocoder.getLocation({
        address: cityValueFull.value
      }).then(result => {
        districtCoor = {
          lat: result.result.location.lat,
          lng: result.result.location.lng
        };
      }).catch(() => {
        districtCoor.lat = '';
        districtCoor.lng = '';
        isSubmit.value = true;
      });
    };
    // 添加标记点
    const addMark = location => {
      if (mapData.marker) {
        mapData.marker.setMap(null);
        mapData.marker = null;
      }
      mapData.marker = new TMap.MultiMarker({
        id: 'marker',
        map: mapData.map
      });
      mapData.marker.add({
        position: location
      });
      mapData.map.setCenter(location);
    };
    // 校验提交前数据 
    const checkSubmit = () => {
      if (!cityValue.value) {
        commonMethod.notify('warning', '请选择省市区');
        return;
      }
      if (!address.value) {
        commonMethod.notify('warning', '请输入详细地址');
        return;
      }
      // 如果是提交的地址和点击后的地址不一样就重新校验
      if (suAddress.value !== address.value) {
        checkArea(address.value).then(() => {
          // 更新一下点击地址
          suAddress.value = address.value;
          if (address.value) {
            checkSubmit1();
          }
        });
        return;
      } else {
        checkSubmit1();
      }
    };
    const checkSubmit1 = () => {
      if (!doorplate.value) {
        commonMethod.notify('warning', '请输入门牌号');
        return;
      }
      if (!isSubmit.value && !noDistrict.value) {
        commonMethod.toast('', '未在此区域内找到所填写的详细地址，建议您在地图上选点操作', 3000);
        return;
      }
      submit();
    };
    const emit = __emit;
    const submit = () => {
      setLocal('adsInfo', address.value);
      emit('submit', {
        city: cityValue.value,
        adr: address.value,
        door: doorplate.value,
        sa_id: sa_id.value
      });
    };
    // 存储地址和门牌号信息
    const setLocal = () => {
      let obj = {
        adr: address.value,
        door: doorplate.value
      };
      window.localStorage.setItem(props.orderId, JSON.stringify(obj));
    };
    // 地图取消
    const cancel = () => {
      cityValue.value = props.area;
      address.value = props.adr;
      doorplate.value = props.door;
      sa_id.value = props.saId;
      suAddress.value = '';
      emit('cancel');
    };
    return (_ctx, _cache) => {
      const _component_van_icon = _resolveComponent("van-icon");
      const _component_van_picker = _resolveComponent("van-picker");
      const _component_van_popup = _resolveComponent("van-popup");
      const _component_van_button = _resolveComponent("van-button");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", {
        class: "down flex flex-between flex-center",
        onClick: _cache[1] || (_cache[1] = $event => (adrShow.value = true, suggestionList.value = []))
      }, [_withDirectives(_createElementVNode("input", {
        class: "adrInput",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => cityValue.value = $event),
        readonly: "",
        placeholder: "省市区、县、乡镇等"
      }, null, 512), [[_vModelText, cityValue.value]]), _createVNode(_component_van_icon, {
        name: "arrow-down"
      })])]), _createElementVNode("div", _hoisted_4, [_hoisted_5, _createElementVNode("div", _hoisted_6, [_withDirectives(_createElementVNode("input", {
        class: "adrInput",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => address.value = $event),
        onInput: _cache[3] || (_cache[3] =
        //@ts-ignore
        (...args) => _unref(getSuggestions) && _unref(getSuggestions)(...args)),
        onBlur: inputBlur,
        placeholder: cityValue.value ? '请填写街道、小区' : '请先选择省市区',
        disabled: !cityValue.value
      }, null, 40, _hoisted_7), [[_vModelText, address.value]])])]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_hoisted_10, _createElementVNode("div", _hoisted_11, [_withDirectives(_createElementVNode("input", {
        class: "adrInput",
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => doorplate.value = $event),
        placeholder: cityValue.value ? '填写门牌号码' : '请先选择省市区',
        disabled: !cityValue.value
      }, null, 8, _hoisted_12), [[_vModelText, doorplate.value]])])]), showSugg.value ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_createElementVNode("ul", _hoisted_14, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(suggestionList.value, item => {
        return _openBlock(), _createElementBlock("li", {
          key: item.id
        }, [_createElementVNode("div", {
          onClick: $event => setSuggestion(item)
        }, [_createTextVNode(_toDisplayString(item.title) + " ", 1), _createElementVNode("span", _hoisted_16, _toDisplayString(item.address), 1)], 8, _hoisted_15)]);
      }), 128))])])) : _createCommentVNode("", true)])]), _hoisted_17, _createVNode(_component_van_popup, {
        show: adrShow.value,
        "onUpdate:show": _cache[6] || (_cache[6] = $event => adrShow.value = $event),
        round: "",
        position: "bottom",
        style: {
          height: '40%'
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_van_picker, {
          columns: areaLists.value,
          onChange: areaChange,
          onCancel: _cache[5] || (_cache[5] = $event => adrShow.value = false),
          onConfirm: onFinish,
          ref_key: "picker",
          ref: picker,
          "show-toolbar": ""
        }, null, 8, ["columns"])]),
        _: 1
      }, 8, ["show"]), _createElementVNode("div", _hoisted_18, [_createVNode(_component_van_button, {
        style: {
          "margin-right": "10px"
        },
        round: "",
        block: "",
        color: "#ccc",
        onClick: cancel
      }, {
        default: _withCtx(() => [_createTextVNode("取消")]),
        _: 1
      }), _createVNode(_component_van_button, {
        type: "primary",
        round: "",
        block: "",
        color: "#b50029",
        onClick: checkSubmit
      }, {
        default: _withCtx(() => [_createTextVNode("确认")]),
        _: 1
      })])], 64);
    };
  }
});